// This file only contains lexiqamus-specific overrides
import 'stylesheets/lexiqamus'